module.exports = __webpack_public_path__ + "img/03.09860b5f.png";